import { render, staticRenderFns } from "./widgetImage.vue?vue&type=template&id=2ef01053&scoped=true&"
import script from "./widgetImage.vue?vue&type=script&lang=js&"
export * from "./widgetImage.vue?vue&type=script&lang=js&"
import style0 from "./widgetImage.vue?vue&type=style&index=0&id=2ef01053&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef01053",
  null
  
)

export default component.exports